// File: src/pages/UploadService.jsx

import { useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";

export default function UploadService() {
  const { user, token } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    businessName: "",
    location: "",
    description: "",
    price: "",
    categories: "",
    image: null,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user || !token) {
      toast.error("You must be logged in to upload a service.");
      return;
    }

    if (!formData.image) {
      toast.error("Please select an image before submitting.");
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        data.append(key, value);
      });

      // ✅ Automatically attach correct ID
      data.append(
        user.role === "vendor" ? "vendorId" : "installerId",
        user._id
      );

      // ✅ Choose correct endpoint
      const endpoint =
        user.role === "vendor"
          ? "https://globisun-app.onrender.com/api/vendor-services"
          : "https://globisun-app.onrender.com/api/installer-services";

      const res = await axios.post(endpoint, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success(res.data.message || "Service uploaded successfully!");
      setFormData({
        businessName: "",
        location: "",
        description: "",
        price: "",
        categories: "",
        image: null,
      });
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error(
        err.response?.data?.message ||
          "Failed to upload service. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="upload-service-container"
      style={{ maxWidth: 500, margin: "0 auto", padding: "1rem" }}
    >
      <h2>Upload Your Service</h2>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "12px" }}
      >
        <input
          name="businessName"
          placeholder="Business Name"
          value={formData.businessName}
          onChange={handleChange}
          required
        />

        <input
          name="location"
          placeholder="Location"
          value={formData.location}
          onChange={handleChange}
          required
        />

        <textarea
          name="description"
          placeholder="Service Description"
          value={formData.description}
          onChange={handleChange}
          required
        />

        <input
          name="price"
          type="number"
          placeholder="Price (₦)"
          value={formData.price}
          onChange={handleChange}
          required
        />

        <input
          name="categories"
          placeholder="Categories (comma separated)"
          value={formData.categories}
          onChange={handleChange}
        />

        <input type="file" name="image" accept="image/*" onChange={handleChange} />

        <button
          type="submit"
          disabled={loading}
          style={{
            background: loading ? "#aaa" : "#007bff",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "6px",
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Uploading..." : "Upload Service"}
        </button>
      </form>
    </div>
  );
}
